<app-coinflip-stats-list [history]="deprecatedCoinflipService.historyCoins().games"
 />
<div class="stats">
  <a class="stats-title" routerLink="history"
    >Last {{ deprecatedCoinflipService.historyCoins().total }} games:</a
  >
  <ul class="stats-list">
    <li>
      <button>
        <app-coinflip-coin [side]="1"></app-coinflip-coin>
        <span class="stats-blue"
          >{{ deprecatedCoinflipService.historyCoins().blue }}%</span
        >
      </button>
    </li>
    <li>
      <button>
        <app-coinflip-coin [side]="2"></app-coinflip-coin>
        <span class="stats-red"
          >{{ deprecatedCoinflipService.historyCoins().red }}%</span
        >
      </button>
    </li>
  </ul>
</div>
